import React from "react";
import { useDisclosure, CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { EditFileRecordListingColumnsConfigDialog } from "./EditFileRecordListingColumnsConfigDialog";

export interface EditFileRecordListingColumnsConfigButtonProps {
    pageSize: number;
    setPageSize(pageSize: number): void;
}

export const EditFileRecordListingColumnsConfigButton: React.FC<EditFileRecordListingColumnsConfigButtonProps> = (
    props: EditFileRecordListingColumnsConfigButtonProps
) => {
    const { isOpen, onClose, onOpen } = useDisclosure();

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.AssetsRead]}>
            <CommandBarButton icon={"Settings"} onClick={onOpen} text={`Config`} />
            {isOpen && (
                <EditFileRecordListingColumnsConfigDialog
                    onClose={onClose}
                    pageSize={props.pageSize}
                    setPageSize={props.setPageSize}
                />
            )}
        </AuthorizationWrapper>
    );
};
